module.exports = __webpack_public_path__ + "static/battle_13-7d608724fa44f958c3527d5a4b72a1d2.jpg";